<script lang="ts" setup>
import ChatListItem from "@/components/mobile/chat/ChatListItem.vue";
import ChatListSkeleton from "@/components/mobile/chat/ChatListSkeleton.vue";
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { isMobile } from "@/modules/common";
import { useChatSession } from "@/stores/chatSession";
import { useGlobalUser } from "@/stores/globalUser";
import { onBeforeMount, ref } from "vue";

const props = defineProps<{
  isCollapsed?: boolean;
  hideHeader?: boolean;
}>();
const emit = defineEmits<{
  (e: "update:isCollapsed", val: boolean): void;
}>();
// 内部状态
const chatSession = useChatSession();
const isLoading = ref(false);

const userStore = useGlobalUser();
// Lifecycle
const prepareData = async () => {
  isLoading.value = true;
  try {
    await chatSession.getOrFetchSessionOverviewList();
  } finally {
    isLoading.value = false;
  }
};

onBeforeMount(async () => {
  if (isMobile()) {
    emit("update:isCollapsed", false);
  }
  await prepareData();
});
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr] lg:pt-4">
    <threads-nav v-if="!props.hideHeader" class="lg:hidden">
      <template #right>
        <span v-show="isLoading" class="loading loading-ring"></span>
      </template>
    </threads-nav>
    <div class="w-full overflow-y-auto">
      <div v-if="userStore.isLogin">
        <div class="flex justify-between p-2">
          <div
            :class="{
              hidden: props.isCollapsed,
            }"
            class="text-base font-semibold"
          >
            {{ $t("Chats.chatSessions") }}
          </div>
          <div class="flex gap-1 items-center">
            <span
              v-show="isLoading"
              class="loading loading-ring hidden lg:inline-block"
            />
            <button
              class="btn btn-sm btn-square btn-ghost hidden lg:block"
              @click="emit('update:isCollapsed', !isCollapsed)"
            >
              <i
                v-if="isCollapsed"
                class="iconify mingcute--layout-leftbar-open-line"
              />
              <i v-else class="iconify mingcute--layout-leftbar-close-line" />
            </button>
          </div>
        </div>
        <div
          v-if="isLoading && chatSession.sessionOverviewList.length === 0"
          class="p-2"
        >
          <ChatListSkeleton />
        </div>
        <div
          v-else-if="chatSession.sessionOverviewList.length > 0"
          class="flex flex-col w-full"
        >
          <chat-list-item
            v-for="item in chatSession.sessionOverviewList"
            :key="item.id"
            :is-collapsed="isCollapsed"
            v-bind="item"
          />
        </div>
        <EmptyContent
          v-else
          :desc="$t('Message.noChatDesc')"
          :title="$t('Message.noChatTitle')"
        />
      </div>
      <ChatExplore v-else />
    </div>
  </div>
</template>
